import { useQuery } from 'react-query';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchProjects } from 'src/services/napi/projects/fetchProjects';
import { useNotification } from '../../../providers/notificationsProvider';

const useGetProjects = async () => {
  const data = await fetchProjects();
  return data?.projects;
};

export const useProjects = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.PROJECTS], () => useGetProjects(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
